import { AxiosPromise } from 'axios';
import { client }       from '@/service/client';

export function getChangelogSettings(): AxiosPromise {
  return client.get('/setup/auto-accept');
}

export function putChangelogSettings(payload: { systemAutoAcceptEnabled: boolean; userAutoAcceptEnabled: boolean }): AxiosPromise {
  return client.put('/setup/auto-accept', payload);
}
